import {
  Directive,
  ElementRef,
  OnDestroy,
  AfterViewInit,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';

declare var PerfectScrollbar;

@Directive({
  selector: '[ps-scrollbar]'
})
export class PerfectScrollbarDirective implements AfterViewInit, OnChanges {
  el: any;

  @Input() isOpen: boolean = false;

  ps: any;

  constructor(el: ElementRef) {
    this.el = el.nativeElement;
  }

  ngAfterViewInit() {}

  ngOnDestroy() {}

  ngOnChanges(changes: SimpleChanges) {
    setTimeout(() => {
      if (this.isOpen) {
        this.ps = new PerfectScrollbar(this.el);
        this.el.scrollTop = 0;
      } else if (this.ps != null) {
        this.ps.destroy();
        this.ps = null;
      }
    }, 100);
  }
}
